import { cn } from "@app/lib/utils";

type FromStartProps = {
  isInView: boolean;
  className?: string;
  children: React.ReactNode;
  direction: "left" | "right" | "top" | "bottom";
};

const animations = {
  left: "animate-from-left rtl:animate-from-right",
  right: "animate-from-right rtl:animate-from-left",
  top: "animate-from-top",
  bottom: "animate-from-bottom",
};

export function AnimateFrom({
  isInView,
  className,
  children,
  direction,
}: FromStartProps) {
  return (
    <div
      className={cn(className, isInView ? animations[direction] : "opacity-0")}
    >
      {children}
    </div>
  );
}
